<template>
  <div>
    <span class="text--disabled">{{ currency.toUpperCase() }}</span
    >&nbsp;
    <span :class="cssClass">{{ display }}</span>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "CurrencyValue",
  props: {
    currency: { type: String, default: "CHF" },
    value: { type: Number },
    limit: { type: Number, default: 0 },
  },
  computed: {
    cssClass() {
      return this.value < this.limit ? "red--text" : "";
    },
    display() {
      return this.value == undefined || this.value == null
        ? "-"
        : this.value.toFixed(2);
    },
  },
});
</script>
